document.querySelectorAll('.beam-contact__form').forEach((form) => {
  const product = new URLSearchParams(window.location.search).get('product')?.trim().slice(0, 250);
  const message = form.querySelector('[name="contact[body]"]');
  const productSelect = form.querySelector('[name="contact[product]"]');
  if (productSelect && product) {
    const option = Array.from(productSelect.options).find((item) => item.value.toLowerCase() === product.toLowerCase());
    if (option) productSelect.value = option.value;
  }
  if (product && message && !message.value) message.value = `Product: ${product}\n\n`;
  form.addEventListener('submit', () => {
    const firstName = form.querySelector('[name="contact[first_name]"]').value.trim();
    const lastName = form.querySelector('[name="contact[last_name]"]').value.trim();
    form.querySelector('[name="contact[name]"]').value = `${firstName} ${lastName}`.trim();
  });
});
